// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rotating-header {
  max-width: 500px;
  padding: 70px 0 40px 0;
  position: relative;
  mask-image: linear-gradient(
    180deg,
    rgba(128, 187, 221, 0) 0%,
    rgba(215, 234, 245, 0.15) 25%,
    rgba(215, 234, 245, 1) 40%,
    rgba(218, 235, 246, 1) 60%,
    rgba(218, 235, 246, 0.05) 90%,
    rgba(255, 255, 255, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    180deg,
    rgba(128, 187, 221, 0) 0%,
    rgba(215, 234, 245, 0.15) 25%,
    rgba(215, 234, 245, 1) 40%,
    rgba(218, 235, 246, 1) 60%,
    rgba(218, 235, 246, 0.05) 90%,
    rgba(255, 255, 255, 0) 100%
  );
}
@media screen and (max-width: 767px) {
  .rotating-header {
    padding: 40px 0;
    mask-image: linear-gradient(
      180deg,
      rgba(128, 187, 221, 0) 0%,
      rgba(215, 234, 245, 0.15) 10%,
      rgba(215, 234, 245, 1) 40%,
      rgba(218, 235, 246, 1) 50%,
      rgba(218, 235, 246, 0.05) 85%,
      rgba(255, 255, 255, 0) 100%
    );
    -webkit-mask-image: linear-gradient(
      180deg,
      rgba(128, 187, 221, 0) 0%,
      rgba(215, 234, 245, 0.15) 10%,
      rgba(215, 234, 245, 1) 40%,
      rgba(218, 235, 246, 1) 50%,
      rgba(218, 235, 246, 0.05) 85%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}

@media screen and (max-width: 400px) {
  .rotating-header {
    padding: 30px 0;
  }
}

.rotating-header svg {
  overflow: visible;
  max-width: 100%;
  height: auto;
}

.header-container {
  position: relative;
  max-width: 580px;
  max-height: 64px;
  margin: 0 auto;
}

#rotating,
#my-data {
  animation-duration: 7s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  animation-delay: 1s;
  animation-fill-mode: both;
}
#rotating {
  transform-origin: 37px 37px;
  transform: rotate(-75deg);
  animation-name: rotate-verbs;
}

#my-data {
  animation-name: slide-text;
}

@keyframes rotate-verbs {
  0% {
    transform: rotate(-75deg);
  }
  10%,
  20% {
    transform: rotate(-60deg);
  }
  30%,
  40% {
    transform: rotate(-45deg);
  }
  50%,
  60% {
    transform: rotate(-30deg);
  }
  70%,
  80% {
    transform: rotate(-15deg);
  }
  90% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@media screen and (max-width: 767px) {
  @keyframes rotate-verbs {
    0% {
      transform: rotate(-75deg);
    }
    10%,
    20% {
      transform: rotate(-60deg);
    }
    30%,
    40% {
      transform: rotate(-45deg);
    }
    50%,
    60% {
      transform: rotate(-30deg);
    }
    70%,
    80% {
      transform: rotate(-15deg);
    }
    90% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg) translateX(45px);
    }
  }
  @keyframes slide-text {
    0%,
    90% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(45px);
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/RotatingHeader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB;;;;;;;;GAQC;EACD;;;;;;;;GAQC;AACH;AACA;EACE;IACE,eAAe;IACf;;;;;;;;KAQC;IACD;;;;;;;;KAQC;EACH;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE;MACE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wCAAwC;IAC1C;EACF;EACA;IACE;;MAEE,0BAA0B;IAC5B;IACA;MACE,2BAA2B;IAC7B;EACF;AACF","sourcesContent":[".rotating-header {\n  max-width: 500px;\n  padding: 70px 0 40px 0;\n  position: relative;\n  mask-image: linear-gradient(\n    180deg,\n    rgba(128, 187, 221, 0) 0%,\n    rgba(215, 234, 245, 0.15) 25%,\n    rgba(215, 234, 245, 1) 40%,\n    rgba(218, 235, 246, 1) 60%,\n    rgba(218, 235, 246, 0.05) 90%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  -webkit-mask-image: linear-gradient(\n    180deg,\n    rgba(128, 187, 221, 0) 0%,\n    rgba(215, 234, 245, 0.15) 25%,\n    rgba(215, 234, 245, 1) 40%,\n    rgba(218, 235, 246, 1) 60%,\n    rgba(218, 235, 246, 0.05) 90%,\n    rgba(255, 255, 255, 0) 100%\n  );\n}\n@media screen and (max-width: 767px) {\n  .rotating-header {\n    padding: 40px 0;\n    mask-image: linear-gradient(\n      180deg,\n      rgba(128, 187, 221, 0) 0%,\n      rgba(215, 234, 245, 0.15) 10%,\n      rgba(215, 234, 245, 1) 40%,\n      rgba(218, 235, 246, 1) 50%,\n      rgba(218, 235, 246, 0.05) 85%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    -webkit-mask-image: linear-gradient(\n      180deg,\n      rgba(128, 187, 221, 0) 0%,\n      rgba(215, 234, 245, 0.15) 10%,\n      rgba(215, 234, 245, 1) 40%,\n      rgba(218, 235, 246, 1) 50%,\n      rgba(218, 235, 246, 0.05) 85%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .rotating-header {\n    padding: 30px 0;\n  }\n}\n\n.rotating-header svg {\n  overflow: visible;\n  max-width: 100%;\n  height: auto;\n}\n\n.header-container {\n  position: relative;\n  max-width: 580px;\n  max-height: 64px;\n  margin: 0 auto;\n}\n\n#rotating,\n#my-data {\n  animation-duration: 7s;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in-out;\n  animation-delay: 1s;\n  animation-fill-mode: both;\n}\n#rotating {\n  transform-origin: 37px 37px;\n  transform: rotate(-75deg);\n  animation-name: rotate-verbs;\n}\n\n#my-data {\n  animation-name: slide-text;\n}\n\n@keyframes rotate-verbs {\n  0% {\n    transform: rotate(-75deg);\n  }\n  10%,\n  20% {\n    transform: rotate(-60deg);\n  }\n  30%,\n  40% {\n    transform: rotate(-45deg);\n  }\n  50%,\n  60% {\n    transform: rotate(-30deg);\n  }\n  70%,\n  80% {\n    transform: rotate(-15deg);\n  }\n  90% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@media screen and (max-width: 767px) {\n  @keyframes rotate-verbs {\n    0% {\n      transform: rotate(-75deg);\n    }\n    10%,\n    20% {\n      transform: rotate(-60deg);\n    }\n    30%,\n    40% {\n      transform: rotate(-45deg);\n    }\n    50%,\n    60% {\n      transform: rotate(-30deg);\n    }\n    70%,\n    80% {\n      transform: rotate(-15deg);\n    }\n    90% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(0deg) translateX(45px);\n    }\n  }\n  @keyframes slide-text {\n    0%,\n    90% {\n      transform: translateX(0px);\n    }\n    100% {\n      transform: translateX(45px);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
